const TimeIcon = ({ className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
      <g clipPath="url(#clip0_141_2355)">
        <circle cx="8.00001" cy="8.12992" r="6.66667" stroke="currentColor" />
        <path
          d="M8.5 4.79657C8.5 4.52043 8.27614 4.29657 8 4.29657C7.72386 4.29657 7.5 4.52043 7.5 4.79657H8H8.5ZM9.35355 8.77635C9.15829 8.58109 8.84171 8.58109 8.64645 8.77635C8.45118 8.97161 8.45118 9.28819 8.64645 9.48346L9 9.1299L9.35355 8.77635ZM9.64645 10.4835C9.84171 10.6787 10.1583 10.6787 10.3536 10.4835C10.5488 10.2882 10.5488 9.97161 10.3536 9.77635L10 10.1299L9.64645 10.4835ZM8 4.79657H7.5V7.1299H8H8.5V4.79657H8ZM9 9.1299L8.64645 9.48346L9.64645 10.4835L10 10.1299L10.3536 9.77635L9.35355 8.77635L9 9.1299ZM9 8.1299H8.5C8.5 8.40605 8.27614 8.6299 8 8.6299V9.1299V9.6299C8.82843 9.6299 9.5 8.95833 9.5 8.1299H9ZM8 9.1299V8.6299C7.72386 8.6299 7.5 8.40605 7.5 8.1299H7H6.5C6.5 8.95833 7.17157 9.6299 8 9.6299V9.1299ZM7 8.1299H7.5C7.5 7.85376 7.72386 7.6299 8 7.6299V7.1299V6.6299C7.17157 6.6299 6.5 7.30148 6.5 8.1299H7ZM8 7.1299V7.6299C8.27614 7.6299 8.5 7.85376 8.5 8.1299H9H9.5C9.5 7.30148 8.82843 6.6299 8 6.6299V7.1299Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_141_2355">
          <rect width="16" height="16" fill="white" transform="translate(0 0.129913)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TimeIcon;
